export const PAGE_HEIGHT_IN_PIXELS = 791.811;

export const TWO_PAGE_HEIGHT_IN_PIXELS = PAGE_HEIGHT_IN_PIXELS * 2;

export const PAGE_HEADER_IN_PIXELS = 195;
